// Tekster for pipeline pakke 5 (Lead inn og inntak): innstillingene for
// inntaket, skjemakoblinger, innboksen for leads, diskvalifiseringsårsaker og
// «Gjør til lead». Egen fil så delene av pakken kan bygges hver for seg.
export const norwegianPipelineIntakeMessages = {
  crm: {
    settings: {
      disqualify_reasons: {
        title: "Diskvalifiseringsårsaker",
        help: "Årsakene vi kan velge når en lead diskvalifiseres. Årsaken er påkrevd i dialogen. Lagringstiden styrer når leaden slettes. En årsak som er brukt, kan skjules, men ikke slettes.",
        label: "Navn",
        hidden_badge: "Skjult",
        hidden: "Skjult",
        retention: "Lagringstid",
        retention_30d: "30 dager",
        retention_12m: "12 måneder",
        need_label: "Alle årsakene må ha et navn.",
        duplicate: "To årsaker kan ikke ha samme navn.",
        in_use: "Brukt på %{count} leads – kan bare skjules",
        in_use_error: "«%{label}» brukes av leads og kan bare skjules.",
        remove: "Slett årsak",
        add: "Legg til årsak",
        save: "Lagre årsakene",
        saved: "Diskvalifiseringsårsakene er lagret",
        save_error: "Diskvalifiseringsårsakene kunne ikke lagres",
      },
      lead_intake: {
        title: "Lead-inntak",
        help: "E-post og skjemavarsler til lead-adressen blir leads i Lead inn. Mimin svarer aldri automatisk til avsenderen.",
        lead_address: "Lead-adresse",
        lead_address_help:
          "Adressen henvendelsene kommer til. En kopi videresendes til Mimins e-postinntak.",
        default_owner: "Standard eier",
        no_owner: "Ingen – leads havner uten eier",
        default_owner_help:
          "Eier for nye leads når kunden eller kontakten ikke har en ansvarlig fra før. Uten standard eier får leaden knappen «Ta denne».",
        limits: "Grenser og svarfrist",
        max_per_sender: "Maks leads per time fra samme adresse",
        max_per_hour: "Maks nye leads per time totalt",
        max_links: "Maks lenker i meldingen",
        max_links_help: "Flere lenker enn dette regnes som spam.",
        reply_cutoff: "Svar samme dag før kl.",
        reply_cutoff_help:
          "Henvendelser etter dette klokkeslettet får svarfrist neste virkedag.",
        lists: "Lister",
        lists_help: "Skill verdiene med komma eller linjeskift.",
        ignored_domains: "Ignorerte domener",
        ignored_domains_help:
          "Leverandører, banker og egne verktøy. E-post fra disse blir aldri leads.",
        ignored_senders: "Ignorerte avsendere",
        ignored_senders_help: "Hele e-postadresser som aldri skal bli leads.",
        free_email_domains: "Gratisdomener",
        free_email_domains_help:
          "E-postdomener som ikke sier noe om kunden (for eksempel gmail.com). De brukes ikke i duplikatsjekken.",
        spam_words: "Spamord",
        spam_words_help:
          "En henvendelse med et av disse ordene blir diskvalifisert som Spam.",
      },
      form_connections: {
        title: "Skjemaer",
        help: "Skjemaverktøy som sender et e-postvarsel for hver innsending. Mimin kjenner varselet igjen på avsenderdomenet og emneprefikset, og henter feltene ut etter feltkoblingen.",
        empty: "Ingen skjemaer er koblet til ennå.",
        inactive: "Ikke aktiv",
        tested_at: "Testet %{date}",
        never_tested: "Ikke testet",
        edit: "Rediger",
        edit_named: "Rediger %{name}",
        name: "Navn",
        tool: "Verktøy",
        tool_formspree: "Formspree",
        tool_other: "Annet",
        kind: "Type",
        kind_email: "E-postvarsel",
        kind_webhook: "Webhook (ikke tilgjengelig ennå)",
        sender_domain: "Avsenderdomene",
        subject_prefix: "Emneprefiks",
        subject_prefix_placeholder: "For eksempel [Nettskjema]",
        subject_prefix_help:
          "Emnet i varselet må begynne med dette. Sett det i skjemaets skjulte subject-felt.",
        field_map: "Feltkobling",
        field_map_help:
          "Feltnavnet slik det står i skjemaet (name-attributtet), og hvor verdien skal i leaden.",
        field_named: "Feltnavn %{n}",
        target_named: "Lead-felt %{n}",
        remove_field: "Fjern felt",
        add_field: "Legg til felt",
        consent_text: "Samtykketekst",
        consent_text_placeholder:
          "Den nøyaktige teksten ved avkrysningen for markedsføring i skjemaet.",
        consent_text_help:
          "Varselet inneholder bare verdien, så teksten lagres her og følger samtykket.",
        active: "Aktiv",
        save: "Lagre skjemakoblingen",
        cancel: "Avbryt",
        add: "Ny kobling",
        add_formspree: "Ny Formspree-kobling",
        need_name: "Koblingen må ha et navn.",
        need_domain: "Fyll ut avsenderdomenet.",
        need_prefix:
          "Fyll ut emneprefikset. Uten det kjennes ikke varselet igjen.",
        duplicate_field: "Et feltnavn står to ganger.",
        saved: "Skjemakoblingen er lagret",
        save_error: "Skjemakoblingen kunne ikke lagres",
        target: {
          contact_name: "Kontakt: navn",
          contact_email: "Kontakt: e-post",
          contact_phone: "Kontakt: telefon",
          company_name: "Kunde: navn",
          company_website: "Kunde: nettsted",
          service: "Tjeneste",
          budget: "Budsjett",
          message: "Melding (første notat)",
          consent: "Samtykke",
          source_page: "Side (kildedetalj)",
          ignore: "Ignorer",
        },
        test: {
          title: "Test mot siste varsel",
          load: "Hent siste varsel",
          run: "Test",
          text: "Tekst fra varselet",
          placeholder:
            "Lim inn teksten fra et skjemavarsel, eller hent siste varsel.",
          loaded: "Siste varsel: %{subject} (%{date})",
          none: "Fant ingen varsler i innboksen. Lim inn teksten i stedet.",
          load_error: "Kunne ikke hente siste varsel",
          ok: "Tolket",
          not_ok:
            "Kunne ikke tolke skjemaet – fant verken e-post eller telefon",
          field: "Felt",
          target: "Lead-felt",
          value: "Verdi",
          unknown: "Ukjente felt (legges nederst i notatet)",
        },
      },
      intake_log: {
        title: "Innboks for leads",
        help: "Det e-postinntaket har tatt imot, og hva det ble til. Rå e-post slettes etter 30 dager.",
        filter_status: "Status",
        all: "Alle",
        count: "%{count} innsendinger",
        empty: "Ingen innsendinger.",
        received_at: "Mottatt",
        from: "Fra",
        subject: "Emne",
        classification_label: "Klassifisering",
        status_label: "Status",
        result: "Resultat",
        open_deal: "Åpne mulighet",
        open_task: "Åpne oppgave",
        status: {
          new: "Ny",
          processed: "Behandlet",
          spam: "Spam",
          ignored: "Ignorert",
          rejected_limit: "Avvist (grense)",
          duplicate: "Duplikat",
          parse_failed: "Kunne ikke tolkes",
        },
        classification: {
          form: "Skjema",
          form_system: "Systemvarsel fra skjema",
          bulk: "Masseutsending",
          ignored_sender: "Ignorert avsender",
          open_deal: "Åpen mulighet",
          customer: "Eksisterende kunde",
          unknown: "Ukjent avsender",
        },
      },
    },
    work_items: {
      to_lead: {
        button: "Gjør til lead",
        done: "Oppgaven er gjort til en lead",
        error: "Kunne ikke gjøre oppgaven til lead",
      },
    },
  },
};

export const englishPipelineIntakeMessages = {
  crm: {
    settings: {
      disqualify_reasons: {
        title: "Disqualification reasons",
        help: "The reasons we can choose when a lead is disqualified. A reason is required in the dialog. The retention period decides when the lead is deleted. A reason that is in use can be hidden, not deleted.",
        label: "Name",
        hidden_badge: "Hidden",
        hidden: "Hidden",
        retention: "Retention",
        retention_30d: "30 days",
        retention_12m: "12 months",
        need_label: "All reasons need a name.",
        duplicate: "Two reasons cannot have the same name.",
        in_use: "Used on %{count} leads – can only be hidden",
        in_use_error: "«%{label}» is used by leads and can only be hidden.",
        remove: "Delete reason",
        add: "Add reason",
        save: "Save reasons",
        saved: "The disqualification reasons are saved",
        save_error: "The disqualification reasons could not be saved",
      },
      lead_intake: {
        title: "Lead intake",
        help: "Email and form notifications to the lead address become leads in Lead inbox. Mimin never replies to the sender automatically.",
        lead_address: "Lead address",
        lead_address_help:
          "The address enquiries arrive at. A copy is forwarded to Mimin's email intake.",
        default_owner: "Default owner",
        no_owner: "None – leads arrive without an owner",
        default_owner_help:
          "Owner of new leads when the customer or contact has no account owner. Without a default owner, the lead gets the «Take this» button.",
        limits: "Limits and reply deadline",
        max_per_sender: "Max leads per hour from the same address",
        max_per_hour: "Max new leads per hour in total",
        max_links: "Max links in the message",
        max_links_help: "More links than this counts as spam.",
        reply_cutoff: "Reply the same day before",
        reply_cutoff_help:
          "Enquiries after this hour get a reply deadline on the next working day.",
        lists: "Lists",
        lists_help: "Separate the values with commas or line breaks.",
        ignored_domains: "Ignored domains",
        ignored_domains_help:
          "Suppliers, banks and our own tools. Email from these never becomes a lead.",
        ignored_senders: "Ignored senders",
        ignored_senders_help:
          "Full email addresses that should never become leads.",
        free_email_domains: "Free email domains",
        free_email_domains_help:
          "Email domains that say nothing about the customer (for example gmail.com). They are not used in the duplicate check.",
        spam_words: "Spam words",
        spam_words_help:
          "An enquiry containing one of these words is disqualified as Spam.",
      },
      form_connections: {
        title: "Forms",
        help: "Form tools that send an email notification for every submission. Mimin recognizes the notification by the sender domain and subject prefix, and extracts the fields using the field mapping.",
        empty: "No forms are connected yet.",
        inactive: "Inactive",
        tested_at: "Tested %{date}",
        never_tested: "Not tested",
        edit: "Edit",
        edit_named: "Edit %{name}",
        name: "Name",
        tool: "Tool",
        tool_formspree: "Formspree",
        tool_other: "Other",
        kind: "Type",
        kind_email: "Email notification",
        kind_webhook: "Webhook (not available yet)",
        sender_domain: "Sender domain",
        subject_prefix: "Subject prefix",
        subject_prefix_placeholder: "For example [Web form]",
        subject_prefix_help:
          "The notification subject must start with this. Set it in the form's hidden subject field.",
        field_map: "Field mapping",
        field_map_help:
          "The field name as it appears in the form (the name attribute), and where the value goes in the lead.",
        field_named: "Field name %{n}",
        target_named: "Lead field %{n}",
        remove_field: "Remove field",
        add_field: "Add field",
        consent_text: "Consent text",
        consent_text_placeholder:
          "The exact text next to the marketing checkbox in the form.",
        consent_text_help:
          "The notification only contains the value, so the text is stored here and follows the consent.",
        active: "Active",
        save: "Save form connection",
        cancel: "Cancel",
        add: "New connection",
        add_formspree: "New Formspree connection",
        need_name: "The connection needs a name.",
        need_domain: "Fill in the sender domain.",
        need_prefix:
          "Fill in the subject prefix. Without it the notification is not recognized.",
        duplicate_field: "A field name appears twice.",
        saved: "The form connection is saved",
        save_error: "The form connection could not be saved",
        target: {
          contact_name: "Contact: name",
          contact_email: "Contact: email",
          contact_phone: "Contact: phone",
          company_name: "Customer: name",
          company_website: "Customer: website",
          service: "Service",
          budget: "Budget",
          message: "Message (first note)",
          consent: "Consent",
          source_page: "Page (source detail)",
          ignore: "Ignore",
        },
        test: {
          title: "Test against latest notification",
          load: "Fetch latest notification",
          run: "Test",
          text: "Notification text",
          placeholder:
            "Paste the text of a form notification, or fetch the latest one.",
          loaded: "Latest notification: %{subject} (%{date})",
          none: "No notifications found in the inbox. Paste the text instead.",
          load_error: "Could not fetch the latest notification",
          ok: "Parsed",
          not_ok: "Could not parse the form – found neither email nor phone",
          field: "Field",
          target: "Lead field",
          value: "Value",
          unknown: "Unknown fields (added at the bottom of the note)",
        },
      },
      intake_log: {
        title: "Lead inbox log",
        help: "What the email intake has received, and what it became. Raw email is deleted after 30 days.",
        filter_status: "Status",
        all: "All",
        count: "%{count} submissions",
        empty: "No submissions.",
        received_at: "Received",
        from: "From",
        subject: "Subject",
        classification_label: "Classification",
        status_label: "Status",
        result: "Result",
        open_deal: "Open opportunity",
        open_task: "Open task",
        status: {
          new: "New",
          processed: "Processed",
          spam: "Spam",
          ignored: "Ignored",
          rejected_limit: "Rejected (limit)",
          duplicate: "Duplicate",
          parse_failed: "Could not be parsed",
        },
        classification: {
          form: "Form",
          form_system: "Form system notice",
          bulk: "Bulk email",
          ignored_sender: "Ignored sender",
          open_deal: "Open opportunity",
          customer: "Existing customer",
          unknown: "Unknown sender",
        },
      },
    },
    work_items: {
      to_lead: {
        button: "Make lead",
        done: "The task is now a lead",
        error: "Could not turn the task into a lead",
      },
    },
  },
};
